/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
// @ts-ignore
import type * as Types from '../../../../../packages/graphql/index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AuthorizationObjectPermissions =
  | 'can_access_wishlist'
  | 'can_edit_company_settings'
  | 'can_edit_contract_conditions'
  | 'can_edit_delivery_zones'
  | 'can_edit_product'
  | 'can_edit_role'
  | 'can_edit_services'
  | 'can_edit_user';

export type AuthorizationObjectType =
  | 'company';

export type AuthorizationCheckQueryVariables = Exact<{
  object: Types.AuthorizationObjectType;
  objectId: string;
}>;


export type AuthorizationCheckQuery = { authorizationCheck: { relations: Array<Types.AuthorizationObjectPermissions> } | null };


export const AuthorizationCheckDocument = /*#__PURE__*/ gql`
    query authorizationCheck($object: AuthorizationObjectType!, $objectId: uuid!) {
  authorizationCheck(object: $object, objectId: $objectId) {
    relations
  }
}
    `;

/**
 * __useAuthorizationCheckQuery__
 *
 * To run a query within a React component, call `useAuthorizationCheckQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuthorizationCheckQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuthorizationCheckQuery({
 *   variables: {
 *      object: // value for 'object'
 *      objectId: // value for 'objectId'
 *   },
 * });
 */
export function useAuthorizationCheckQuery(baseOptions: Apollo.QueryHookOptions<AuthorizationCheckQuery, AuthorizationCheckQueryVariables> & ({ variables: AuthorizationCheckQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AuthorizationCheckQuery, AuthorizationCheckQueryVariables>(AuthorizationCheckDocument, options);
      }
export function useAuthorizationCheckLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AuthorizationCheckQuery, AuthorizationCheckQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AuthorizationCheckQuery, AuthorizationCheckQueryVariables>(AuthorizationCheckDocument, options);
        }
// @ts-ignore
export function useAuthorizationCheckSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AuthorizationCheckQuery, AuthorizationCheckQueryVariables>): Apollo.UseSuspenseQueryResult<AuthorizationCheckQuery, AuthorizationCheckQueryVariables>;
export function useAuthorizationCheckSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AuthorizationCheckQuery, AuthorizationCheckQueryVariables>): Apollo.UseSuspenseQueryResult<AuthorizationCheckQuery | undefined, AuthorizationCheckQueryVariables>;
export function useAuthorizationCheckSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AuthorizationCheckQuery, AuthorizationCheckQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AuthorizationCheckQuery, AuthorizationCheckQueryVariables>(AuthorizationCheckDocument, options);
        }
export type AuthorizationCheckQueryHookResult = ReturnType<typeof useAuthorizationCheckQuery>;
export type AuthorizationCheckLazyQueryHookResult = ReturnType<typeof useAuthorizationCheckLazyQuery>;
export type AuthorizationCheckSuspenseQueryHookResult = ReturnType<typeof useAuthorizationCheckSuspenseQuery>;
export type AuthorizationCheckQueryResult = Apollo.QueryResult<AuthorizationCheckQuery, AuthorizationCheckQueryVariables>;